import React, { useState } from "react";
import {
  Box,
  Checkbox,
  InputBase,
  List,
  ListItem,
  ListItemText,
  Button,
  Card as MuiCard,
  Typography,
} from "@material-ui/core";
import { Search } from "@material-ui/icons";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router";
import { joinChannel } from "../../../redux/actions/programAction";
import useStyles from "./style";
import { useSearchCommunity } from "../../../util/hooks";

import logo from "../../../assets/logo.png";
import backIcon from "../../../assets/icons/backIcon.svg";

interface CommunityScreenProps {
  handleNextPhase: () => void;
  setSelectedCommunity: (community: string) => void;
  selectedCommunity: string | null;
}

const CommunityScreen: React.FC<CommunityScreenProps> = ({
  handleNextPhase,
  setSelectedCommunity,
  selectedCommunity,
}) => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const { setSearchQuery, filteredCommunities } = useSearchCommunity();

  const auth = JSON.parse(localStorage.getItem("authInfo") || "{}");
  const activeProgramEnrollment = JSON.parse(
    localStorage.getItem("activeProgramEnrollment") || "{}"
  );

  const handleChange = (community: string) => {
    setSelectedCommunity(community);
  };

  const handleJoin = () => {
    if (!selectedCommunity) {
      alert("Please select a community before joining.");
      return;
    }
    dispatch(
      joinChannel(
        activeProgramEnrollment.programId,
        auth._id,
        activeProgramEnrollment.communityIdentifier,
        selectedCommunity
      )
    );
    handleNextPhase();
  };

  return (
    <div className={classes.container}>
      <MuiCard className={classes.card}>
        <Box className={classes.header}>
          <Box onClick={() => history.push("/user/dashboard")}>
            <img src={backIcon} alt="Back" className={classes.backIcon} />
          </Box>
          <Box className={classes.logoWrapper}>
            <img src={logo} alt="Logo" className={classes.logo} />
          </Box>
        </Box>

        <Typography className={`${classes.titleCon} ${classes.onboardingTitle}`} component="h1">
          Welcome
        </Typography>
        <Typography className={`${classes.titleCon} ${classes.onboardingHeading}`} component="h2">
          Join a Community
        </Typography>


        {/* Search Input */}
        <div className={classes.searchInput}>
          <InputBase
            placeholder="Search"
            fullWidth
            startAdornment={
              <Search style={{ marginRight: 8, cursor: "pointer" }} />
            }
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>

        {/* Community List */}
        {filteredCommunities?.length > 0 && (
          <List className={classes.communityListWrapper}>
            {filteredCommunities.map((data, index) => (
              <ListItem
                key={index}
                button
                onClick={() => handleChange(data?.communityIdentifier)}
              >
                <ListItemText primary={data.communityName} />
                <Checkbox
                  checked={selectedCommunity === data.communityIdentifier}
                  icon={<span className={classes.checkBoxIcon} />}
                  checkedIcon={
                    <span className={classes.checkedIcon}>
                      <svg
                        viewBox="0 0 24 24"
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          width: "14px",
                          height: "14px",
                          stroke: "#2158D0",
                          strokeWidth: 2,
                          fill: "none",
                        }}
                      >
                        <path d="M5 12l5 5L20 7" />
                      </svg>
                    </span>
                  }
                />
              </ListItem>
            ))}
          </List>
        )}

        {/* Join Button */}
        <Button
          type="submit"
          fullWidth
          size="small"
          className={classes.submitBtn}
          onClick={handleJoin}
        >
          Join
        </Button>

        {/* Logout Button */}
        <Button
          fullWidth
          size="small"
          style={{
            marginTop: '12px',
            color: '#666',
            textTransform: 'none',
            fontSize: '14px'
          }}
          onClick={() => {
            localStorage.clear();
            window.location.href = "/login";
          }}
        >
          Logout
        </Button>
      </MuiCard>
    </div>
  );
};

export default CommunityScreen;
